import { faceImgList, oldFaceImgList } from './utils';

const imgList = [...faceImgList, ...oldFaceImgList];

const renderEmoji = (html) => {
    let formatedHtml = html;

    if (formatedHtml && html) {
        imgList.forEach((item, index) => {
            const reg = `\\[${item.name}\\]`;
            const regExp = new RegExp(reg, 'g');

            let imgUrl = '';

            if (regExp.test(html)) {
                imgUrl = require(`../icons/${item.name}.png`);

                formatedHtml = formatedHtml.replace(regExp, `<img src="${imgUrl}" />`);
            }
        });
    }

    return formatedHtml;
};

export default renderEmoji;
